import { createUseStyles, withTheme } from '@glu/theming';
import PropTypes from 'prop-types';
import { CaretDownIcon } from '@glu/icons-react';
import React from 'react';
import styles from './StyledSelect.styles';

const useStyles = createUseStyles(styles);

const StyledSelect = ({ children, ...rest }) => {
  const classes = useStyles(rest);

  return (
    <div className={classes.wrapper}>
      {children}
      <div className={classes.caret}>
        <CaretDownIcon />
      </div>
    </div>
  );
};

StyledSelect.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withTheme(StyledSelect);
